import React from 'react'
import { TooltipHost } from '@fluentui/react'
import { ChannelMembershipType } from '../../GlobalConst/globalEnums';
import { renderQuotaUsage, rootSiteQuotaUsage, channelsQuotaUsage } from "../../helpers/HelperMethods";

const ChannelsDetails = ({ site }) => {

    const siteQuotaUsage = rootSiteQuotaUsage(site);
    const privateChannels = site.channels.filter(x => x.channelType === ChannelMembershipType.private);
    const sharedChannels = site.channels.filter(x => x.channelType === ChannelMembershipType.shared) ;  
    const privateChannelsQuotaUsage = channelsQuotaUsage(privateChannels);
    const sharedChannelsQuotaUsage = channelsQuotaUsage(sharedChannels);
    const totalChannelsQuotaUsage = privateChannelsQuotaUsage + sharedChannelsQuotaUsage;
    const privateChannelsCount = privateChannels.length;
    const sharedChannelsCount = sharedChannels.length;

    const btnChannelsStyles = {
        marginLeft: '10px',
        marginRight: '10px',
        height: '18px',
        fontSize: 12,
        fontWeight: 400,
        color: 'rgb(0, 120, 212)',
        textDecoration: 'underline',
        cursor: 'pointer'
    }
    
    const channelsDetailsContent =
    <table>
        <tbody>
            <tr style={{fontWeight:'bold', marginBottom:'4px'}}><td>Root site:</td><td style={{float:'right'}}>{renderQuotaUsage(siteQuotaUsage)}</td></tr>
            <tr style={{fontWeight:'bold', marginBottom:'4px'}}><td>Total Channels:</td><td style={{float:'right'}}>{renderQuotaUsage(totalChannelsQuotaUsage)}</td></tr>
            <tr style={{marginBottom:'4px'}}><td>Private Channels ({privateChannelsCount}):</td><td style={{float:'right'}}>{renderQuotaUsage(privateChannelsQuotaUsage)}</td></tr>
            <tr style={{marginBottom:'4px'}}><td style={{marginBottom:'4px'}}>Shared Channels ({sharedChannelsCount}):</td><td style={{float:'right'}}>{renderQuotaUsage(sharedChannelsQuotaUsage)}</td></tr>
        </tbody>
    </table>

    return (
        <TooltipHost content={channelsDetailsContent}>
            <span style={btnChannelsStyles}>Channels details</span>
        </TooltipHost>
    )
}

export default ChannelsDetails


// WEBPACK FOOTER //
// ./src/components/CustomComponents/ChannelsDetails.js